import React from "react";
import Header from "components/Header/Header";
import Hero from "components/Hero/Hero";
import Projects from "components/Projects/Projects"
import HowItWorksSection from "components/HowItWorksSection/HowItWorksSection";
import StartYourPathSection from "components/StartYourPathSection/StartYourPathSection";
import ContactUsSection from "components/ContactUsSection/ContactUsSection";
import Footer from "components/Footer/Footer";
import { threeStepFlow } from 'data/HowItWorksSteps';
import ProgressBar from "components/ProgressBar/ProgressBar";

const MainPage = () => {
    return (
        <div className='overlay'>
            <Header />
            <Hero />
            <Projects />
            <HowItWorksSection steps={threeStepFlow} />
            <ProgressBar progress={65} />
            <StartYourPathSection/>
            <ContactUsSection />
            <Footer />
        </div>
    );
};

export default MainPage;

